import { isMobile, isTablet } from 'react-device-detect';

var mult = isMobile || isTablet ? 2 : 1;
var multtext = isMobile || isTablet ? 1 : 1;
export const WildItem = {
	name: 'WildItem',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'wild',
			type: 'AnimatedSprite',
			position: { x: 0, y: -10 },
			animation: {
				pattern: 'money$.png',
				start: 0,
				end: 95,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 1 * mult,
					y: 1 * mult
				}
			}
		},
		{
			name: 'wild',
			type: 'AnimatedSprite',
			position: { x: -8, y: 140 },
			animation: {
				pattern: 'wx5_000$.png',
				start: 0,
				end: 22,
				speed: 0.5,
				loop: true,
				precision: 2,
				scale: {
					x: multtext,
					y: multtext
				}
			}
		}
	]
};
